import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

// CONSTANTS
import colors, { tenantColors } from '../../../_constants/colors'

export const StyledNote = styled.div`
  display: flex;
  justify-items: center;
  text-align: center;
  background-color: ${(props) =>
    props.activeTenantColors ? props.activeTenantColors.secondary : colors.DEFAULT_SECONDARY};
  color: white;
  border-radius: 5px;
  padding: 15px;
  font-weight: bold;

  @media screen and (min-width: 600px) {
    grid-template-columns: max-content auto;
    justify-items: left;
    text-align: left;
  }

  .icon {
    background-color: white;
    color: ${(props) => (props.activeTenantColors ? props.activeTenantColors.secondary : colors.DEFAULT_SECONDARY)};
    border-radius: 100px;
    padding: 5px;
    padding: 0.25em;
    font-size: 1.5rem;
  }

  .message {
    font-size: 0.9em;
    line-height: 1.5em;
    margin-left: 1em;
    a {
      color: white;
      text-decoration: underline;
      transition: all 0.2s ease-in-out;

      &:hover {
        opacity: 0.75;
      }
    }
  }
`

const Note = ({ tenant, icon, message }) => {
  const IconComponent = icon
  return (
    <StyledNote activeTenantColors={tenantColors[tenant]} className={`note`}>
      {IconComponent && <IconComponent className={`icon`} />}
      <p className={`message`}>{message}</p>
    </StyledNote>
  )
}

function mapStateToProps(state) {
  const { env } = state
  return {
    tenant: env.tenant,
  }
}

const connectedNote = connect(mapStateToProps, null)(Note)
export { connectedNote as Note }
